const currentYear = new Date().getFullYear();
export const yearsTable = Array.from(
  { length: (currentYear + 5) - 1980 + 1 },
  (_, i) => (currentYear + 5) - i
);
